import React, { Component } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./sidebar";

class BlogSlider extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let customClass = this.props.customClass ? this.props.customClass : "";
    let sectionClass = this.props.sectionClass ? this.props.sectionClass : "";

    const blogData = [
      {
        img: "assets/img/blog/news-3.webp",
        link: "https://propakistani.pk/?p=837483&preview=1&_ppp=b11776af1e&v9",
        author: "ProPakistani",
        tag: "lithuimbattery",
        title:
          "Atom Power Launches Pakistan’s First Locally Assembled Batteries",
        date: "December 03, 2024",
      },
      {
        img: "assets/img/blog/news-1.webp",
        link: "https://propakistani.pk/2024/10/31/elfa-paves-the-way-for-locally-engineered-transportation-in-pakistan/amp/",
        author: "ProPakistani",
        tag: "electricbike",
        title:
          "ELFA Paves the Way for Locally-Engineered Transportation in Pakistan",
        date: "September 12, 2024",
      },
      {
        img: "assets/img/blog/news-2.webp",
        link: "https://www.brecorder.com/news/40322000",
        author: "BusinessRecorder",
        tag: "ncrwavetec",
        title: "BML partners with NCR, Wavetec to elevate self-banking network",
        date: "October 31, 2024",
      },
      {
        img: "assets/img/blog/atom-elfa-news.webp",
        link: "https://propakistani.pk/2025/06/25/elfa-e-bikes-now-run-on-atom-power/",
        author: "ProPakistani",
        tag: "electricbike",
        title:
          "Atom Power x Elfa Electric Bikes - powering up the future together!",
        date: "June 25, 2025",
      },
    ];

    return (
      // <div className={"ltn__blog-area pt-115--- pb-70 go-top " + sectionClass}>
      // Remove Padding top
      <div className={"ltn__blog-area pt-115--- pb-70 go-top "}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                {/* <h6
                  className={
                    "section-subtitle ltn__secondary-color " + customClass
                  }
                >
                  News &amp; Blogs
                </h6> */}
                <h1 className="section-title">News &amp; Blogs</h1>
              </div>
            </div>
          </div>
          <div className="row ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
            {blogData.map((item, index) => (
              <div className="col-lg-12" key={index}>
                <div className="ltn__blog-item ltn__blog-item-3">
                  <div className="ltn__blog-img">
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={publicUrl + item.img} alt="Blog" />
                    </a>
                  </div>
                  <div className="ltn__blog-brief">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-author">
                          <div>
                            <i className="far fa-user" /> by: {item.author}
                          </div>
                        </li>
                        <li className="ltn__blog-tags">
                          <div>
                            <i className="fas fa-tags" /> {item.tag}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <h3 className="ltn__blog-title">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => window.open(item.link, "_blank")}
                      >
                        {item.title}
                      </div>
                    </h3>
                    <div className="ltn__blog-meta-btn">
                      <div className="ltn__blog-meta">
                        <ul>
                          <li className="ltn__blog-date">
                            <i className="far fa-calendar-alt" /> {item.date}
                          </li>
                        </ul>
                      </div>
                      <div className="ltn__blog-btn">
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Read more
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default BlogSlider;
